export default __webpack_public_path__ + "static/media/no_picture.1287f47e.jpg";